import React from "react";
import {Link as ScrollLink} from "react-scroll";
import {updateUrlWithMethodName} from "../../utils/sideBarUtils";

function SearchList({searchResults}) {
  return (
    <ul>
      {searchResults.map((result, index) => (
        <ScrollLink
          key={index}
          activeClass="none"
          to={`${result[1]}`}
          // to={`#${result}`}
          spy={true}
          smooth={true}
          offset={-150}
          duration={0}
        >
          <li key={index}>
            <p onClick={()=>updateUrlWithMethodName(result[0])}>{result[0]}</p>
          </li>
        </ScrollLink>
      ))}
    </ul>
  );
}

export default SearchList;
